<div class="dialog">
  <span class="dialog-close" (click)="close()">
    <i class="fa fa-close"></i>
  </span>
  <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
  <div class="dialog-content">
    <div *ngFor="let user of users">
      <div class="row">
        <div class="col-sm-3">
          <img [src]="user.logo.url" alt="{{ user.first_name }}" class="img-circle" />
          <div style="margin-top: 10px">
            <span *ngIf="user.activated_at" class="label label-success">
              <i class="fa fa-check"></i> <b>{{ 'ACCOUNT_CONFIRMED' | translate }}</b>
            </span>
            <span *ngIf="!user.activated_at" class="label label-warning">
              <i class="fa fa-clock-o"></i> <b>{{ 'PENDING_ACTIVATION' | translate }}</b>
            </span>
          </div>
        </div>
        <div class="col-sm-9">
          <ul class="list-unstyled">
            <li>
              <h3>
                {{ user.first_name }} {{ user.last_name }}
                <span
                  class="label"
                  ng-class="user.status === 'active' ? ' label-primary' : ' label-default'"
                >
                  {{ user.status === 'active' ? ('ACTIVE' | translate) : ('INACTIVE' | translate) }}
                </span>
              </h3>
            </li>
            <li><i class="fa fa-envelope fa-sized"></i> {{ user.email }}</li>
            <li><i class="fa fa-phone fa-sized"></i> {{ user.phone }} / {{ user.mobile }}</li>
            <li>
              <i class="fa fa-map-marker fa-sized"></i> {{ user.country.country_code }}
              {{ user.country.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="dialog-actions">
      <!-- Close -->
      <span class="btn btn-lg" (click)="close()">
        <i class="fa fa-undo"></i> {{ 'CLOSE' | translate }}
      </span>
    </div>
  </div>
</div>
